var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogOut = function SvgIconLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_5877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 5.83333L12.9917 7.00833L15.1417 9.16667H6.66669V10.8333H15.1417L12.9917 12.9833L14.1667 14.1667L18.3334 10L14.1667 5.83333ZM3.33335 4.16667H10V2.5H3.33335C2.41669 2.5 1.66669 3.25 1.66669 4.16667V15.8333C1.66669 16.75 2.41669 17.5 3.33335 17.5H10V15.8333H3.33335V4.16667Z",
    fill: "#1A2B47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_5877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export default SvgIconLogOut;